import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import { IComponentData } from '../../store/editor/components/state'
import * as EditorCoreHelpers from '../../store/editor/core/helpers'
import { Actions, Getters } from '../../store/editor/components/helpers'

@Component({
  props: {
    id: {
      type: String,
      required: true
    }
  }
})
export default class ComponentVue<T extends IComponentData> extends Vue {
  $store: Store<RootState>
  id: string
  isFocusEnabled: boolean = false

  get componentData(): T {
    return <T>this.getComponentData(this.id)
  }

  get hasFocus(): boolean {
    return this.isFocusEnabled && EditorCoreHelpers.Getters.focusedComponentId(this.$store) === this.id
  }

  getComponentData(id: string): IComponentData {
    return Getters.componentFinder(this.$store)(id)
  }

  save(data: IComponentData): void {
    Actions.update(this.$store, data)
  }

  deleteComponent(): void {
    Actions.remove(this.$store, this.componentData)
  }

  enableFocus(): void {
    this.isFocusEnabled = true
  }

  focus(): void {
    if (this.isFocusEnabled) {
      EditorCoreHelpers.Mutations.requestFocus(this.$store, this.id)
    }
  }

  forceFocus(): void {
    if (this.isFocusEnabled) {
      EditorCoreHelpers.Mutations.forceFocus(this.$store, this.id)
    }
  }
}
